import { defineStore } from 'pinia';

export const publicData = defineStore('publicData',
{
    state: () => (
    {
        userName: '',
        password: '',

        name: '',
        department: '',
        jobPosition: '',
        manager: false,

        information_PAS: null,
        information_loanRecords: null,
        information_tasksManagement: null,
        bulletinInfos_original: null,
        bulletinInfos_search: null,
        information_qualityManagement: null,
        information_closedLoopManagement: null,
    }),

    getters:
    {
        doubleCount: (state) => state.counter * 2,
    },

    actions:
    {
        increment()
        {
            this.counter++;
        },
    },
});
